import {Component, Input, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ItemDetailModel} from '../../models/item-detail.model';
import {ItemModel} from '../../models/item.model';
import {AngularFireAuth} from 'angularfire2/auth';
import {DomSanitizer} from '@angular/platform-browser';
import {NgxGalleryImage, NgxGalleryOptions} from 'ngx-gallery';

@Component({
  selector: 'app-modal-detail',
  templateUrl: './modal-detail.component.html',
  styleUrls: ['./modal-detail.component.css']
})
export class ModalDetailComponent implements OnInit {

  @Input('modal') modal: NgbModalRef;
  @Input('item') item: ItemModel;
  loanItems: ItemDetailModel[] = [];
  selectedItem: ItemDetailModel = new ItemDetailModel();

  image: NgxGalleryImage[];
  imageOptions: NgxGalleryOptions[];

  selectImage: NgxGalleryImage[];
  selectImageOptions: NgxGalleryOptions[];

  constructor(private http: HttpClient, private modalService: NgbModal, private auth: AngularFireAuth, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {

    if (this.item.pk) {
      this.item.loanItemsPk = this.item.pk;
    }
    if (this.item.loanItemPk) {
      this.item.loanItemsPk = this.item.loanItemPk;
    }

    this.imageOptions = [
      {
        width: '350px',
        height: 'calc(100vh - 620px)',
        thumbnailsColumns: 0,
        thumbnails: false,
        thumbnailsArrows: false,
        imageArrows: false,
        arrowPrevIcon: '',
        arrowNextIcon: '',
      },
    ];

    this.auth.auth.currentUser.getIdToken(true)
      .then(token => {
        const headers = new HttpHeaders();
        headers.append('Authorization', token);

        return this.http.get(this.item.imgURL, {headers: headers, responseType: 'blob'}).toPromise();  /* this.item.imgURL */
      }).then(res => {
      this.item.itemImageUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));

      return this.image = [
        {
          small: window.URL.createObjectURL(res),
          medium: window.URL.createObjectURL(res),
          big: window.URL.createObjectURL(res)
        },
      ];

    });

    this.loadDetaiItems();
  }

  close() {
    this.modal.close();
  }

  clickRow(loanItem: ItemDetailModel) {
    Object.assign(this.selectedItem, loanItem);
    console.log(loanItem);

    this.selectImageOptions = [
      {
        width: '350px',
        height: 'calc(100vh - 620px)',
        thumbnailsColumns: 0,
        thumbnails: false,
        thumbnailsArrows: false,
        imageArrows: false,
        arrowPrevIcon: '',
        arrowNextIcon: '',
      },
    ];

    this.auth.auth.currentUser.getIdToken(true).then(token => {
      const headers = new HttpHeaders();
      headers.append('Authorization', token);

      return this.http.get(this.selectedItem.imgURL, {headers: headers, responseType: 'blob'}).toPromise();  /* this.selectedItem.imgURL */
    }).then(res => {
      this.selectedItem.selectedImageUrl = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));

      return this.selectImage = [
        {
          small: window.URL.createObjectURL(res),
          medium: window.URL.createObjectURL(res),
          big: window.URL.createObjectURL(res)
        },
      ];
    });

    if (loanItem.imgURL === null) {
      this.selectImage = [];
    }

  }

  // 해당 대출 아이템 가져오기.
  loadDetaiItems() {
    const loanOutPk = 'temp';
    this.http.get<any>('//api.feelwaypawnshop.com/api/loanout/' + loanOutPk + '/loanitems/' + this.item.loanItemsPk + '/history', {})
      .subscribe(response => {
        console.log(response);
        response.forEach(receiptItem => {
          this.loanItems.push(receiptItem);
        });
      });
  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/pages/common/components/modal-detail/modal-detail.component.ts